import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';
import PropTypes from 'prop-types';
import Waiting from '../components/waiting';

export default class TackPauseAll extends React.Component {
  static propTypes = {
    user: UserShape,
    onPauseAllTacks: PropTypes.func
  }

  componentDidMount() {
    this.props.onPauseAllTacks();
  }

  render() {
    if (this.props.user.get('pauseAll')) {
      return this.renderAllPaused();
    } else if (this.props.user.get('error')) {
      return this.renderPauseAllError();
    } else {
      return this.renderPausing();
    }
  }

  renderAllPaused() {
    return(
      <div className='row confirmation'>
        <div className='col-sm-12'>
          { `No problem. We've paused all your tacks. You won't receive any more tack emails.` }
        </div>
        <div className='col-sm-12 action'>
          <Link to='/tacks/resume_all' className='btn btn-outline-secondary'>Oops. Resume All</Link>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Thanks</Link>
        </div>
      </div>
    )
  }

  renderPausing() {
    return(
      <Waiting waitingText={ 'Pausing All Tacks' } />
    )
  }

  renderPauseAllError() {
    return(
      <div className='error'>
        Hmm, we had a problem pausing all tacks. Try again?
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_pause_all.jsx